import { Editor, Node, Text, Transforms } from 'slate';

import { ELEMENT_PARAGRAPH } from 'components/text_editor_new/plugins/paragraph';

export default function normalizeEditor(editor, options = {}) {
  if (options.trimParagraphWhitespace) {
    // Go through each block, trim the text from the front
    for (const [, blockPath] of Editor.nodes(editor, {
      at: [],
      match: n => {
        return n.type === ELEMENT_PARAGRAPH;
      },
    })) {
      let firstTextEntry;
      for (const textEntry of Editor.nodes(editor, {
        at: blockPath,
        match: n => Text.isText(n),
      })) {
        firstTextEntry = textEntry;
        break;
      }

      if (!firstTextEntry) {
        break;
      }

      const [firstText, firstTextPath] = firstTextEntry;
      const startTrimmed = firstText.text.replace(/^[^\S\r\n]+/, '');
      const firstStartDiff = firstText.text.length - startTrimmed.length;

      if (firstStartDiff > 0) {
        Transforms.delete(editor, {
          at: {
            offset: 0,
            path: firstTextPath,
          },
          distance: firstStartDiff,
        });
      }
    }

    // Go through each block, trim the text from the end (only space-like characters, not newlines)
    for (const [, blockPath] of Editor.nodes(editor, {
      at: [],
      match: n => {
        return n.type === ELEMENT_PARAGRAPH;
      },
    })) {
      let lastTextEntry;
      for (const textEntry of Editor.nodes(editor, {
        at: blockPath,
        match: n => Text.isText(n),
        reverse: true,
      })) {
        lastTextEntry = textEntry;
        break;
      }

      if (!lastTextEntry) {
        break;
      }

      const [lastText, lastTextPath] = lastTextEntry;
      const lastTrimmed = lastText.text.replace(/[^\S\r\n]+$/, '');
      const lastDiff = lastText.text.length - lastTrimmed.length;

      if (lastDiff > 0) {
        Transforms.delete(editor, {
          at: {
            offset: lastText.text.length,
            path: lastTextPath,
          },
          distance: lastDiff,
          reverse: true,
        });
      }
    }
  }

  // Remove empty paragraphs at beginning / end of message
  if (options.trimEmptyParagraphs) {
    // Go forwards to trim the front empty paras
    let shouldBreak = false;
    while (!shouldBreak) {
      for (const [block, blockPath] of Editor.nodes(editor, {
        at: [],
        match: n => {
          return n.type === ELEMENT_PARAGRAPH;
        },
        mode: 'highest',
      })) {
        const text = Node.string(block);
        if (text.trim() === '' && editor.children.length > 1) {
          Transforms.removeNodes(editor, { at: blockPath });
          break;
        } else {
          shouldBreak = true;
          break;
        }
      }

      if (editor.children.length <= 1) {
        break;
      }
    }

    shouldBreak = false;
    // Go backwards to trim the back empty paras
    while (!shouldBreak) {
      for (const [block, blockPath] of Editor.nodes(editor, {
        at: [],
        match: n => {
          return n.type === ELEMENT_PARAGRAPH;
        },
        mode: 'highest',
        reverse: true,
      })) {
        const text = Node.string(block);
        if (text.trim() === '' && editor.children.length > 1) {
          Transforms.removeNodes(editor, { at: blockPath });
          break;
        } else {
          shouldBreak = true;
          break;
        }
      }
    }
  }
}
